import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAccessToken } from '@editor2/services/apiService';

export interface JwtState {
	token: string;
}

export const fetchAccessToken = createAsyncThunk(
	'fetchAccessToken',
	async (oneTimeToken: string) => {
		const response = await getAccessToken(oneTimeToken);
		return response.data;
	}
);

const jwtSlice = createSlice({
	name: 'jwt',
	initialState: { token: null },
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchAccessToken.fulfilled, (state, action) => {
			state.token = action.payload;
		});
	}
});

export default jwtSlice.reducer;
